export default __webpack_public_path__ + "static/media/SWT1400.34I-35234_-20465_0.910534f8.jpg";